import React from 'react';
import { withRouter } from "react-router-dom";
import AnnualReviewsFilter from './AnnualReviewsFilter.Component';



const MonitorLanding = (props) => {
    return <AnnualReviewsFilter setRecentSearch={props.setRecentSearch} recentSearch={props.recentSearch} loggedUserInfo={props.loggedUserInfo} userId={props.userId} clientId={props.clientId} />
}
export default withRouter(MonitorLanding);